import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import floatingStyles from '../elements/floatingLabelInput/floatingLabelInput.module.scss';

// antd multi-select in the floating-label look (same as ProductForm). The
// `multiSelect` wrapper lets the box grow with its tags; a bare antd Select is
// pinned to one line by globals.scss and wrapped tags overflow it.
export default function FloatingMultiSelect({
  id,
  label,
  placeholder,
  value,
  options,
  disabled,
  onChange,
}) {
  return (
    <div
      className={`${floatingStyles.floatingLabel} ${floatingStyles.multiSelect} ${value?.length ? floatingStyles.hasValue : ''}`}
    >
      <Select
        id={id}
        mode="multiple"
        style={{ width: '100%' }}
        placeholder={placeholder}
        value={value}
        options={options}
        disabled={disabled}
        onChange={onChange}
      />
      <label htmlFor={id} className={floatingStyles.label}>
        {label}
      </label>
    </div>
  );
}

FloatingMultiSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  ).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};
